<template>
  <div class="row">
    <div class="col-md-3" v-for="card in cards" :key="card.label">
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <h4 class="text-muted">
            {{ card.label }}
            <CalculationTooltip :text="card.tooltip" />
          </h4>
          <p class="h3">
            {{ card.current }}
            <span class="small" :class="card.changeClass">
              {{ card.changeText }}
            </span>
          </p>
          <p class="text-muted small">Previous: {{ card.previous }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';
import { inDollars } from '../../../../DriveScout/Billing/Teller';

export default {
  name: 'EcommerceYoYComparison',
  components: { CalculationTooltip },
  props: {
    summary: { type: Object, required: true },
    yoyComparison: { type: Object, required: true }
  },
  computed: {
    cards() {
      if (!this.summary || !this.yoyComparison) return [];
      var yoy = this.yoyComparison;
      return [
        {
          label: 'Revenue YoY',
          current: inDollars(this.summary.total_revenue),
          previous: inDollars(yoy.previous_period.total_revenue), // DS-PORT-DEFECT (drivescout-vue3 M6 slice 5, 2026-10-17): row S5-ecommerce-yoy-previous-wrong-path: yoy.previous_period carries only start_date/end_date (EcommerceDashboardController::getYoyComparison), so this reads undefined and inDollars' default prints "$0.00"; the previous revenue is yoy.total_revenue. FIXED in the port (owner ruling 2026-10-18)
          changeText: this.formatChange(yoy.revenue_change_percent),
          changeClass: this.changeClass(yoy.revenue_change_percent),
          tooltip: 'Compares total revenue in the current period against the previous period.'
        },
        {
          label: 'Orders YoY',
          current: Number(this.summary.total_orders).toLocaleString(),
          previous: Number(yoy.previous_period.total_orders).toLocaleString(), // DS-PORT-DEFECT (drivescout-vue3 M6 slice 5, 2026-10-17): row S5-ecommerce-yoy-previous-wrong-path: yoy.previous_period has no total_orders, so Number(undefined) prints "NaN"; the previous order count is yoy.total_orders. FIXED in the port (owner ruling 2026-10-18)
          changeText: this.formatChange(yoy.orders_change_percent),
          changeClass: this.changeClass(yoy.orders_change_percent),
          tooltip: 'Compares total order count in the current period against the previous period.'
        }
      ];
    }
  },
  methods: {
    formatChange(pct) {
      if (pct == null) return '';
      var sign = pct >= 0 ? '+' : '';
      return sign + pct + '%';
    },
    changeClass(pct) {
      if (pct == null) return '';
      return pct >= 0 ? 'text-success' : 'text-danger';
    }
  }
};
</script>
